import { usePermissions } from "../../../session/permissions";

export interface InboxPermissions {
  isPending: boolean;
  reply: boolean;
  takeover: boolean;
  assign: boolean;
  export: boolean;
  /** "Add to knowledge" needs inbox.reply + knowledge.create (DEC-031). */
  addToKnowledge: boolean;
}

/** Effective inbox permissions on the conversation's agent (agent-scoped roles count). */
export function useInboxPermissions(agentId: string | null): InboxPermissions {
  const permissions = usePermissions(agentId);
  const scope = agentId ? { agentId } : { anywhere: true };
  const writable = !permissions.readOnly;
  const can = (key: Parameters<typeof permissions.can>[0]) => writable && permissions.can(key, scope);
  const reply = can("inbox.reply");
  return {
    isPending: permissions.isPending,
    reply,
    takeover: can("inbox.takeover"),
    assign: can("inbox.assign"),
    export: permissions.can("inbox.export", scope),
    addToKnowledge: reply && can("knowledge.create"),
  };
}
